import { types } from 'mobx-state-tree';

const NotificationTypeField = types
  .model('NotificationTypeField', {
    id: types.identifierNumber,
    name: types.string
  })
  .views(self => {
    return {
      get isNewField() : boolean {
        return self.id === 0;
      }
    };
  })
  .actions(self => {
    return {
      setName(name : string) {
        self.name = name;
      }
    };
  });

const NotificationType = types
  .model('NotificationType', {
    id: types.identifierNumber,
    name: types.string,
    fields: types.array(NotificationTypeField)
  })
  .views(self => {
    return {
      get editingNewField() : boolean {
        return self.fields.findIndex(field => field.id === 0) !== -1;
      }
    };
  })
  .actions(self => {
    return {
      addNewField() {
        if (self.editingNewField)
          return;

        self.fields.push(NotificationTypeField.create({ id: 0, name: ''}));
      },
      cancelAdd() {
        const index = self.fields.findIndex(x => x.id === 0);
        if(index >= 0)
          self.fields.splice(index, 1);
      }
    };
  });

export default NotificationType;
export type INotificationType = typeof NotificationType.Type;
export type INotificationTypeField = typeof NotificationTypeField.Type;